"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Level = exports.Kind = void 0;
var Kind = exports.Kind = /*#__PURE__*/function (Kind) {
  Kind["DEFAULT"] = "default";
  Kind["LIGHTER"] = "lighter";
  Kind["DISABLED"] = "disabled";
  Kind["INTERACTION"] = "interaction";
  Kind["INTERACTION_HOVERED"] = "interactionHovered";
  Kind["INTERACTION_SPECIAL"] = "interactionSpecial";
  Kind["INTERACTION_SPECIAL_HOVERED"] = "interactionSpecialHovered";
  Kind["CRITICAL"] = "critical";
  Kind["WARNING"] = "warning";
  Kind["POSITIVE"] = "positive";
  Kind["DECORATIVE"] = "decorative";
  Kind["INVERSE"] = "inverse";
  Kind["INVERSE_LIGHTER"] = "inverseLighter";
  Kind["INVERSE_DISABLED"] = "inverseDisabled";
  Kind["INVERSE_ON_DISABLED"] = "inverseOnDisabled";
  Kind["ON_DISABLED"] = "onDisabled";
  Kind["ON_DECORATIVE"] = "onDecorative";
  Kind["ON_SELECTED"] = "onSelected";
  Kind["ON_SELECTED_HOVERED"] = "onSelectedHovered";
  return Kind;
}(Kind || {});
var Level = exports.Level = /*#__PURE__*/function (Level) {
  Level["HERO_LARGE"] = "heroLarge";
  Level["HERO_MEDIUM"] = "heroMedium";
  Level["HERO_SMALL"] = "heroSmall";
  Level["DISPLAY"] = "display";
  Level["HEADING"] = "heading";
  Level["TITLE"] = "title";
  Level["BODY"] = "body";
  Level["BODY_STRONG"] = "bodyStrong";
  Level["CAPTION"] = "caption";
  Level["CAPTION_STRONG"] = "captionStrong";
  return Level;
}(Level || {});